export interface AppRoleOption {
  key: string;
  label: string;
  value: number;
}

export const APP_ROLE_OPTIONS: AppRoleOption[] = [
  { key: 'ADMIN', label: 'Admin', value: 1 },
  { key: 'SUPER_ADMIN', label: 'Super Admin', value: 2 },
  { key: 'AGENT', label: 'Agent', value: 4 },
  { key: 'CARRIER', label: 'Carrier', value: 8 },
  { key: 'CONSIGNEE', label: 'Consignee', value: 16 },
  { key: 'CUSTOMER', label: 'Customer', value: 32 },
  { key: 'CUSTOMER_CARE', label: 'Customer Care', value: 64 },
  { key: 'DISPATCHER', label: 'Dispatcher', value: 128 },
  { key: 'DRIVER', label: 'Driver', value: 256 },
  { key: 'FINANCE', label: 'Finance', value: 512 },
  { key: 'MASTER', label: 'Master', value: 1024 },
  { key: 'OPERATIONS', label: 'Operations', value: 2048 },
  { key: 'SALES', label: 'Sales', value: 4096 },
  { key: 'SHIPPER', label: 'Shipper', value: 8192 },
  { key: 'SHIPPING_RECEIVING', label: 'Shipping Receiving', value: 16384 },
  { key: 'AUTHOR', label: 'Author', value: 32768 },
  { key: 'EMPLOYEE', label: 'Employee', value: 65536 },
  { key: 'SUBSCRIBER', label: 'Subscriber', value: 131072 },
  { key: 'PUBLISHER', label: 'Publisher', value: 262144 },
  { key: 'SUPER_EDITOR', label: 'Super Editor', value: 524288 },
  { key: 'SUPER_MODERATOR', label: 'Super Moderator', value: 1048576 },
  { key: 'TRANSLATOR', label: 'Translator', value: 2097152 },
  { key: 'MODERATOR', label: 'Moderator', value: 4194304 },
  { key: 'EDITOR', label: 'Editor', value: 8388608 },
  { key: 'CONSULTANT', label: 'Consultant', value: 16777216 },
  { key: 'MAINTAINER', label: 'Maintainer', value: 33554432 },
  { key: 'CONTRIBUTOR', label: 'Contributor', value: 67108864 },
  { key: 'MANAGER', label: 'Manager', value: 134217728 },
  { key: 'COLLABORATOR', label: 'Collaborator', value: 268435456 },
  { key: 'CONSUMER', label: 'Consumer', value: 536870912 },
  { key: 'COORDINATOR', label: 'Coordinator', value: 1073741824 },
  { key: 'CREATOR', label: 'Creator', value: 2147483648 },
  { key: 'DEVELOPER', label: 'Developer', value: 4294967296 },
  { key: 'DIRECTOR', label: 'Director', value: 8589934592 },
  { key: 'REVIEWER', label: 'Reviewer', value: 17179869184 },
  { key: 'ID10T', label: 'ID10T', value: 34359738368 },
];

export function maskIncludesRole(mask: number, roleValue: number): boolean {
  if (!Number.isFinite(mask) || !Number.isFinite(roleValue) || roleValue <= 0) {
    return false;
  }

  return Math.floor(mask / roleValue) % 2 === 1;
}

export function getRoleOptionsFromMask(mask: number): AppRoleOption[] {
  return APP_ROLE_OPTIONS.filter((role) => maskIncludesRole(mask, role.value));
}

export function getRoleLabelsFromMask(mask: number): string[] {
  return getRoleOptionsFromMask(mask).map((role) => role.label);
}
